import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query staffPicks($tenantId: ID!, $suggestionsListId: ID!) {
    staffPicks(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
